import { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  const addToCart = (product, quantity = 1, color = null, size = null) => {
    const uniqueKey = `${product.id}-${product.color || 'noColor'}-${product.size || 'noSize'}`;
  
    setItems(prevItems => {
      const existingItem = prevItems.find(item => item.uniqueKey === uniqueKey);
  
      if (existingItem) {
        return prevItems.map(item =>
          item.uniqueKey === uniqueKey
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      } else {
        return [
          ...prevItems,
          {
            productId: product.id, // 🔑 ürün ID'si doğrudan kaydediliyor
            product,
            quantity,
            color: color,
            size: size,
            uniqueKey
          }
        ];
      }
    });
  };
  
  
  
  

  const removeFromCart = (uniqueKey) => {
    setItems(prevItems => prevItems.filter(item => 
      !(item.uniqueKey === uniqueKey)
    ));
  };

  const updateQuantity = (uniqueKey, quantity) => {
    if (quantity <= 0) {
      removeFromCart(uniqueKey); // Burada removeFromCart fonksiyonunu da güncellemelisin
      return;
    }
    
    setItems(prevItems => 
      prevItems.map(item => 
        item.uniqueKey === uniqueKey 
          ? { ...item, quantity } // Doğru renk ve beden kombinasyonunun miktarını güncelle
          : item
      )
    );
  };
  

  const clearCart = () => {
    setItems([]);
  };

  const getCartTotal = () => {
    return items.reduce((total, item) => total + (item.product.price * item.quantity), 0);
  };

  const getCartCount = () => {
    return items.reduce((count, item) => count + item.quantity, 0);
  };

  const value = {
    items,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getCartTotal,
    getCartCount
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};